import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { TextField, Box } from '@mui/material';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function AutocompleteCqlFecha({ cqlFecha, handleDateChange }) {
  const datePart = cqlFecha.split(' ')[0]; // yyyy-MM-dd
  const timePart = cqlFecha.split(' ')[1]; // HH:mm:ss

  const handleDateChangeInternal = (event) => {
    const newDatePart = event.target.value;
    handleDateChange(`${newDatePart} ${timePart}`);
  };

  // Detección simple
  const { isChromium, isFirefox, isSafari } = useMemo(() => {
    if (typeof navigator === 'undefined') {
      return { isChromium: false, isFirefox: false, isSafari: false };
    }
    const ua = navigator.userAgent;
    const isChromium = /Chrome|Chromium|CriOS/i.test(ua) && !/Edg/i.test(ua);
    const isFirefox = /Firefox/i.test(ua);
    const isSafari = /AppleWebKit/i.test(navigator.userAgent) && !/Chrome/i.test(navigator.userAgent) || /iPad|iPhone|iPod/.test(navigator.platform);
    return { isChromium, isFirefox, isSafari };
  }, []);

  const forceLightScheme = isChromium || isFirefox || isSafari;
  const isWebKit = isChromium || isSafari;
  if (isSafari) {
    return (
      <Box sx={{
        width: '100%',
        maxWidth: 180,
        boxSizing: 'border-box',
        mt: '10px',
        backgroundColor: 'rgba(20, 20, 20, 0.7)',
        borderRadius: '12px',
        height: '35px',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid rgba(255,255,255,0.1)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
        position: 'relative',


        cursor: 'pointer',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',


        '&:hover': {
          borderColor: '#1565c0',
        }
      }}>
        <label style={{
          position: 'absolute',
          top: '-10px',
          left: '12px',
          fontSize: '0.75rem',
          color: 'rgba(255,255,255,0.9)',
          backgroundColor: '#121212',
          padding: '0 4px',
          zIndex: 11,
          pointerEvents: 'none',
          userSelect: 'none',
          whiteSpace: 'nowrap',
        }}>
          Date
        </label>
        <style>
          {`
                    .react-datepicker-popper {
                      z-index: 999999 !important;
                    }
                    .react-datepicker__portal {
                      z-index: 999999 !important;
                    }
                  `}
        </style>
        <DatePicker
          selected={datePart ? new Date(datePart + 'T00:00:00') : new Date()}
          onChange={(date) => {
            if (date) {
              // Fix BUG-4: toISOString() devuelve UTC y puede dar el día anterior
              // en zonas horarias con offset positivo (UTC+N). Usamos date-fns
              // format() que siempre respeta la fecha local del usuario.
              const formatted = format(date, 'yyyy-MM-dd');
              handleDateChange(`${formatted} ${timePart}`);
            }
          }}
          dateFormat="dd/MM/yyyy"
          portalId="root"
          popperPlacement="top-start"
          customInput={

            <Box
              component="input"
              readOnly

              onMouseDown={(e) => {
                // Fix BUG-3: NO llamar preventDefault() en mousedown.
                // En WebKit/Safari cancela el focus y el DatePicker no abre.
                // Solo prevenimos doble-click para evitar selección de texto.
                if (e.detail > 1) e.preventDefault();
              }}
              sx={{
                background: 'transparent',
                border: 'none',
                outline: 'none',
                color: {
                  xs: '#fff',
                  md: 'transparent',
                  lg: '#fff'
                },
                fontWeight: 600,
                fontSize: '0.9rem',
                fontFamily: '"Open Sans", sans-serif',
                width: '100%',
                height: '100%',
                padding: '10px',
                position: 'relative',
                zIndex: 100,
                boxSizing: 'border-box',


                cursor: 'pointer',
                userSelect: 'none',
                WebkitUserSelect: 'none',

                caretColor: 'transparent',
                marginRight: { xs: '0px', sm: '0px', md: '12px', lg: '0px' },
                marginLeft: '5px',
              }}
            />

          }
        />
      </Box>
    );
  }
  return (
    <TextField
      label="Select Date"
      type="date"
      value={datePart}
      onChange={handleDateChangeInternal}
      InputLabelProps={{ shrink: true }}


      onClick={(e) => {

        const input = e.currentTarget.querySelector('input');
        if (input && typeof input.showPicker === 'function') {
          try {
            input.showPicker();
          } catch (err) {

            console.warn("showPicker not supported", err);
          }
        }
      }}



      inputProps={{
        onSelect: (e) => e.preventDefault(),
      }}
      sx={{
        width: 190,
        mt: '10px',
        cursor: 'pointer',
        userSelect: 'none',
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'rgba(0,0,0,0.75)',
          color: '#fff',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
          backdropFilter: 'blur(2px)',
          cursor: 'pointer',
          userSelect: 'none',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#14599e !important' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1565c0 !important' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },


          '& input[type="date"]': {
            padding: '12px',
            color: '#fff',
            WebkitTextFillColor: '#fff',
            colorScheme: forceLightScheme ? 'light' : 'dark',
            cursor: 'pointer',

            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            caretColor: 'transparent',
          },


          '& input[type="date"]::-webkit-clear-button': { display: 'none' },
          '& input[type="date"]::-webkit-inner-spin-button': { display: 'none' },


          '& input[type="date"]::-webkit-calendar-picker-indicator': {

            ...(isWebKit ? { filter: 'invert(1) brightness(1.6)' } : {}),
            opacity: 0.95,
            cursor: 'pointer',
            selected: 'none',

            marginRight: { xs: '0px', sm: '0px', md: '12px', lg: '0px' },
            marginLeft: '5px',

            position: 'static',
          },
          // ---------------------------------------------------------

          // Firefox
          '& input[type="date"]::-moz-focus-inner': { border: 0 },

          // Por si algún highlight se cuela
          '& input[type="date"]::selection': { background: 'transparent' },
          '& input[type="date"]::-moz-selection': { background: 'transparent' },
        },

        '& .MuiInputLabel-root': {
          color: 'rgba(255,255,255,0.9)',
          '&.Mui-focused': { color: '#ffffff' },
          cursor: 'pointer',

          pointerEvents: 'none',
        },
      }}
    />
  );
}

export default AutocompleteCqlFecha;
